import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Autosizer, Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const TransportGroupTransportList = () => {
  const { transports } = useSelector((state) => state.transport.groupSelectedItem);

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
        '.MuiListItem-root': {
          width: '100%',
          userSelect: 'none',
          padding: theme.spacing(0),
          borderRadius: '0',
          '&:hover': {
            cursor: 'pointer',
            bgcolor: 'background.default',
          },
          '&.Mui-selected': {
            '.MuiListItemText-root': {
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            },
          },
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            borderRadius: '0',
          },
          '.MuiListItemText-root': {
            display: 'flex',
            flex: 'none',
            height: '100%',
            margin: theme.spacing(0),
            padding: theme.spacing(0, 1),
            alignItems: 'center',
            '&:first-of-type': {
              paddingLeft: theme.spacing(2),
            },
            '&:last-of-type': {
              flex: '1',
              paddingRight: theme.spacing(2),
            },
            '.MuiTypography-root': {
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            },
          },
          '.MuiListItemAvatar-root': {
            minWidth: '26px',
          },
          '.MuiAvatar-circular': {
            width: '24px',
            height: '24px',
            color: theme.palette.primary.main,
            padding: theme.spacing(0),
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            svg: {
              fontSize: '16px',
              path: {
                fill: theme.palette.primary.main,
              },
            },
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => (
                <FixedSizeList
                  height={height}
                  itemSize={36}
                  overscanCount={10}
                  itemCount={transports.length}
                  innerRef={contentNodeRef}
                  outerRef={scrollableNodeRef}
                  innerElementType={TransportGroupTransportInnerElementType}
                  itemData={{
                    items: transports,
                  }}>
                  {TransportGroupTransportItemRender}
                </FixedSizeList>
              )}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const TransportGroupTransportInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const TransportGroupTransportItemRender = ({ data, index, style }) => {
  const { items } = data;

  return (
    <ListItem key={items[index].id} style={style}>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <TransportRoundedIcon fontSize='small' />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} />
      </ListItemButton>
    </ListItem>
  );
};

export default TransportGroupTransportList;
